<template>
  <card :class="[baseCss]" full-height>
    <card-title v-if="header" v-html="header" :class="['select-none']" :bg-color="uiBgColor" :bg-color-lightness="uiBgColorLightness" :color="uiColor" :color-lightness="uiColorLightness" />
    <card-text padding-off :class="[`${baseCss}-list`, 'relative']" :style="{height: listHeight}">
      <list v-if="items.length" :clickable="multiple" :data-list="list">
        <list-item tabindex="0" :title="item.text" v-for="(item, index) in items" :disabled="item.disabled" :key="index" @dblclick.native="!multiple ? select(index) : null" @click="multiple ? select(index) : null">
          <list-item-icon  v-if="multiple">
            <checkbox :icon-color="uiBgColor" :icon-color-lightness="uiBgColorLightness" v-model="item.selected" :class="['pointer-events-none']" />
          </list-item-icon>
          <list-item-content :class="[!multiple ? ['pl-4', 'py-4'] : null]">
            <list-item-content-sub-title v-if="dense" v-html="item.text" />
            <list-item-content-title v-else v-html="item.text" />
          </list-item-content>
          <list-item-icon v-if="item.icon">
            <icon :name="item.icon" :color="uiBgColor" :color-lightness="uiBgColorLightness" :provider="iconProvider" />
          </list-item-icon>
          <list-item-icon v-if="!multiple && list === 'right'">
            <icon :class="['cursor-pointer']" @click.native="select(index)" name="close" :color="uiBgColor" :color-lightness="uiBgColorLightness" :provider="iconProvider" />
          </list-item-icon>
          <list-item-icon v-if="!multiple && list === 'left'">
            <icon :class="['cursor-pointer']" @click.native="select(index)" :name="iconRight" :color="uiBgColor" :color-lightness="uiBgColorLightness" :provider="iconProvider" />
          </list-item-icon>
        </list-item>
      </list>
      <empty v-else :icon-size="iconEmptySize" :class="['absolute', 'w-full']" :icon="iconEmpty" :icon-provider="iconProvider" :color="iconEmptyColor" :color-lightness="iconEmptyColorLightness" />
    </card-text>
    <template v-if="$slots['footer-left']">
      <card-actions :align="footerAlign" padding-off>
        <slot name="footer-left" />
      </card-actions>
    </template>
    <template v-if="$slots['footer-right']">
      <card-actions :align="footerAlign" padding-off>
        <slot name="footer-right" />
      </card-actions>
    </template>
  </card>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'TransferList',
  mixins: [
    methods
  ],
  data () {
    return {
      baseCss: this.componentBaseCss('transfer-list', [])
    }
  },
  props: {
    items: {
      type: Array,
      default: () => {
        return []
      }
    },
    iconRight: {
      type: String
    },
    multiple: {
      type: Boolean
    },
    list: {
      type: String,
      required: true
    },
    iconEmptySize: {
      type: Number
    },
    iconEmptyColor: {
      type: String
    },
    iconEmptyColorLightness: {
      type: Number
    },
    header: {
      type: String
    },
    iconEmpty: {
      type: String
    },
    uiBgColor: {
      type: String
    },
    uiBgColorLightness: {
      type: Number
    },
    dense: {
      type: Boolean
    },
    uiColor: {
      type: String
    },
    uiColorLightness: {
      type: Number
    },
    listHeight: {
      type: String
    },
    footerAlign: {
      type: String
    },
    iconProvider: {
      type: String
    }
  },
  methods: {
    select (index) {
      this.items[index].selected = !this.items[index].selected
      this.$emit('select', {
        list: this.list,
        items: this.items,
        multiple: this.multiple
      })
    }
  }
}
</script>
<style>
.bcq-transfer .bcq-transfer-list .bcq-transfer-list-list
{
  overflow: auto !important;
}

.bcq-transfer .bcq-transfer-list .bcq-empty
{
  top: 50%;
  transform: translateY(-50%);
}
</style>



// WEBPACK FOOTER //
// src/bcq-ui/components/transfer/transfer-list.vue